/**
 *  意见反馈功能
 *  2019/10/14
 *  Bai.Zhiming
 */
angular.module('feedBackModule', [
    'feedBackServiceModule'
]).directive('feedBackBtn', ['$timeout', 'feedBackService', function($timeout, feedBackService) {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        templateUrl: './feedBack/feedBack_tpl.html',
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                let position = localStorage.getItem("feedBackPosition");
                position = !position ? {} : JSON.parse(position);
                scope.status = {
                    feedBackPosition: {
                        top: position.top,
                        left: position.left,
                        bottom: 'initial',
                        right: 'initial'
                    }
                };
                scope.data = {};
                dragAndDrop();
            }
            /**
             * [submitFeedBack description] 提交反馈
             * @return {[type]} [description]
             */
            scope.submitFeedBack = function(){
                feedBackService.submitFeedBack().then(()=>{},()=>{});
            };
            /**
             * [myFeedBack description] 我的反馈
             * @return {[type]} [description]
             */
            scope.myFeedBack = function(){
                feedBackService.myFeedBack().then(()=>{},()=>{});
            };
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {}
            /**
             * [dragAndDrop description] 支持弹窗拖拽功能
             * @return {[type]} [description]
             */
            function dragAndDrop() {
                $timeout(() => {
                    $element.draggable({
                        containment: "body",
                        handle: ".tab",
                        start(event, ui) {},
                        stop() {
                            saveWindowPosition();
                        }
                    });
                }, 1000);
            }
            /**
             * [saveWindowPosition description] 储存按钮位置
             * @param  {[type]} left [description]
             * @param  {[type]} top  [description]
             * @return {[type]}      [description]
             */
            function saveWindowPosition() {
                let boundingClientRect = $element[0].getBoundingClientRect();
                let position = localStorage.getItem("feedBackPosition");
                position = !position ? {} : JSON.parse(position);
                let feedBackPosition = {
                    left: boundingClientRect.left + "px",
                    top: boundingClientRect.top + "px",
                    bottom: 'initial',
                    right: 'initial'
                };
                scope.status.feedBackPosition = angular.copy(feedBackPosition);
                position = angular.extend(position, feedBackPosition);
                localStorage.setItem('feedBackPosition', JSON.stringify(position));
            }
        }
    };
}]);